package org.zq.astrock_ai.quant

import kotlin.math.PI
import kotlin.math.sin

object DemoBars {
    /**
     * 用确定性正弦波生成演示日 K，便于无真实行情时回测。
     */
    fun synthesize(
        seedPrice: Double,
        days: Int = 120,
        seed: Int = 0,
    ): List<QuantBar> {
        val base = seedPrice.coerceAtLeast(1.0)
        val out = ArrayList<QuantBar>(days)
        var prev = base
        for (i in 0 until days) {
            val wave = sin((i + seed) * 0.18) * 0.035 + sin((i + seed) * 0.05) * 0.02
            val drift = i * 0.0004
            val close = (base * (1 + wave + drift)).coerceAtLeast(0.5)
            val open = prev
            val high = maxOf(open, close) * (1.005 + ((i + seed) % 5) * 0.001)
            val low = minOf(open, close) * (0.995 - ((i + seed) % 4) * 0.001)
            val month = ((i % 12) + 1).toString().padStart(2, '0')
            val day = ((i % 28) + 1).toString().padStart(2, '0')
            out += QuantBar(
                date = "2026-$month-$day",
                open = open,
                high = high,
                low = low,
                close = close,
                volume = 8_000_000.0 + (sin(i * PI / 17) + 1) * 3_000_000,
            )
            prev = close
        }
        return out
    }
}
